import React, { useState, useEffect } from "react";
import * as ANTD from "antd";
import {
  PlusCircleFilled,
  UploadOutlined,
  LoadingOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  CloseOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Image,
  Input,
  Modal,
  message,
  Radio,
  Select,
  Spin,
  Table,
  Row,
  Upload,
  Popconfirm,
} from "antd";
import HelpInfoHelper from "../../common/HelpInfoHelper/HelpInfoHelper";
import "./Hotelroomtypes.scss";
import excel from "../assets/vector-icons/excel.png";
import search from "../assets/vector-icons/search.png";
import APIClient from "../../../src/helpers/ApiClient";
import exchange from "../assets/vector-icons/exchange.png";
import ApiClient from "../../../src/helpers/ApiClient";
import UpdatedComponent from "../ExportExcel";
// import { getHotelType } from "./Hotelhelper";
const Hotelroomtypes = (props) => {
  const { Header, Footer, Sider, Content } = ANTD.Layout;
  const [form] = ANTD.Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const date = new Date();
  const [updateModal, setUpdateModal] = React.useState(false);
  const [deleteModal, setdeleteModal] = React.useState(false);
  const [moreInfoModal, setInfoModal] = React.useState(false);
  const [formLayout, setFormLayout] = useState("vertical");
  const [showUpdateBtn, setShowUpdateBtn] = useState(false);
  const { TextArea } = ANTD.Input;
  const [imgUrl, setImgUrl] = useState();
  const [loading, setLoading] = useState(false);
  const imageUrl = imgUrl;
  const [actHotelForm] = Form.useForm();
  const [showSearchBox, setShowSearchBox] = useState(false);
  const [roomList, setRoomList] = useState([]);
  const [addValue, setValue] = useState();
  const [currentId, setCurrentId] = useState();
  const [excelList, setExcelList] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const handleRoleType = (val) => setRoleType(val);
  const [roleType, setRoleType] = useState(1);
  const [addMarkupModal, setAddMarkupModal] = useState(false);

  useEffect(() => {
    getHotelroomList();
  }, []);

  {
    /*get method*/
  }

  const getHotelroomList = () => {
    APIClient.get("hotelsextranet/getHotelRoomType")
      .then((res) => {
        if (res.status == 200) {
          let data = res.data.map((item, index) => {
            return {
              SNo: index + 1,

              ...item,
            };
          });
          // let filteredNmaes = data?.filter(
          //   (item) => item.HotelRoomTypeId != 2 && item.HotelRoomTypeId != 5
          // );
          setRoomList(data);
          defineExcelData(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  {
    /*post method*/
  }
  const AddHoteltype = (nameObjtest) => {
    APIClient.post("hotelsextranet/createHotelRoomType", nameObjtest)
      .then((response) => {
        return response;
      })
      .then((response) => {
        if (response.status == 200) {
          setAddMarkupModal(false);
          ANTD.message.success("Successfully added Room", 3);
          getHotelroomList();
        } else if (response.status == 400) {
          ANTD.message.error("Room Already existed", 3);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  {
    /*put method*/
  }
  const UpdateHotelType = (nameObj) => {
    console.log(currentId);
    ApiClient.put(
      "hotelsextranet/updateHotelRoomType/" + currentId,
      {},
      nameObj
    ).then((res) => {
      if (res.status == 200) {
        getHotelroomList();
        ANTD.message.success("Room Updated successfully", 3);
        setAddMarkupModal(false);
      } else {
        ANTD.message.error(" Error Uploading Data", 3);
      }
    });
  };
  {
    /*delet method*/
  }
  const deleteName = (id) => {
    APIClient.delete("hotelsextranet/deleteHotelRoomType/" + id)
      .then((res) => {
        if (res.status == 200) {
          ANTD.message.success("Name Deleted  successfully", 3);
          getHotelroomList();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  {
    /*from method*/
  }
  const onFinish = (val) => {
    let nameObj = {
      Status: 0,
      // Name: val.Name,
      ImagePath: "string",
      Description: val.Description,
      RoomTypeName: val.RoomTypeName,
      CreatedBy: 0,
      CreatedDate: new Date(),
      ModifiedBy: 0,
      ModifiedDate: new Date(),
    };
    isEdit ? UpdateHotelType(nameObj) : AddHoteltype(nameObj);
  };

  const add = () => {
    let nameObjtest = {
      Name: addValue,
      Level: "1",
      CreatedBy: 1,
    };
  };

  const defineExcelData = (data) => {
    const filteredData = data.map((item) => {
      const obj = {
        RoomType: item.RoomTypeName,
        Description: item.Description,
        CreatedDate: item.CreatedDate,
        ModifiedDate: item.ModifiedDate,
        Status: item.status === 1 ? "Active" : "Inactive",
      };
      return obj;
    });
    setExcelList(filteredData);
  };

  const searchTableData = (e) => {
    var searchVal = e.target.value;
    if (searchVal.length > 0) {
      const searchResults = roomList.filter(function (item) {
        if (item != undefined) {
          return JSON.stringify(item)
            .toLowerCase()
            .includes(searchVal.toLowerCase());
        }
      });
      setRoomList(searchResults);
    } else {
      getHotelroomList();
      setRoomList(roomList);
    }
  };

  function getInputValue(event) {
    setValue(event.target.value);
  }

  const deleteToggle = () => {
    setdeleteModal(!deleteModal);
  };
  const layout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 15 },
  };

  const handleChange = (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(
        info.file.originFileObj,
        (imageUrl) => setImgUrl(imageUrl),
        setLoading(false)
      );
    }
  };
  const searchData = (searchData) => {
    setShowSearchBox(true);
  };
  const closeSearch = () => {
    setShowSearchBox(false);
  };

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      ANTD.message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      ANTD.message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  }

  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
  };
  /***** Radio-btn*****/
  const [discountBtn, setDiscountBtn] = useState(1);

  /****** User Info ******/
  const [userInfo, setUserInfo] = useState(false);

  const openUserInfo = () => {
    setUserInfo(true);
  };

  const handleOk = (e) => {
    console.log(e);
    setUserInfo(false);
  };

  const handleCancel = (e) => {
    console.log(e);
    setUserInfo(false);
  };

  let onChange = (jsDate, dateString) => {
    console.log(jsDate);
    console.log(dateString);
  };
  let lastIndex = 0;
  const uniqueKey = () => {
    lastIndex++;
    return lastIndex;
  };
  const tableActions = (currentRecord) => {
    return (
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        <div className="edit-icon" style={{ textAlign: "center" }}>
          <EditOutlined
            onClick={() => editCurrentItem(currentRecord)}
            style={{ color: "#1890ff", fontSize: "20px", textAlign: "center" }}
          />
        </div>
        <div className="edit-icon" style={{ textAlign: "center" }}>
          <ANTD.Popconfirm
            title="Are you sure to delete?"
            onConfirm={() => deleteName(currentRecord.HotelRoomTypeId)}
          >
            <DeleteOutlined
              style={{ color: "red", fontSize: "20px", textAlign: "center" }}
            />
          </ANTD.Popconfirm>
        </div>
      </div>
    );
  };

  const editCurrentItem = (rec) => {
    setCurrentId(rec.HotelRoomTypeId);
    actHotelForm.setFieldsValue({
      Description: rec.Description,
      RoomTypeName: rec.RoomTypeName,
    });

    setIsEdit(true);
    setAddMarkupModal(true);
  };

  const { Option } = ANTD.Select;

  const config = {
    rules: [{ type: "object", required: true, message: "Please select time!" }],
  };

  const dataSource = [
    {
      name: "Jhon",
      description: "bbb",

      actions: tableActions(),
      /* delete: tableDelete(), */
    },
    {
      name: "Jhon11",
      description: "aaa",

      actions: tableActions(),
      /* delete: tableDelete(), */
    },
    {
      name: "Jhon2",
      description: "ccc",

      actions: tableActions(),
      /* delete: tableDelete(), */
    },
  ];

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "SNo",
    },
    {
      title: "Room Type Name",
      dataIndex: "RoomTypeName",
    },
    // {
    //   title: "Name",
    //   dataIndex: "Name",
    //   sorter: (a, b) => a.Name.localeCompare(b.Name),
    // },

    {
      title: "Description",
      dataIndex: "Description",
      sorter: (a, b) => a.Description.localeCompare(b.Description),
    },

    {
      title: "Status",
      dataIndex: "no",
      key: "airline",
      render: (text, order) => (
        <ANTD.Switch
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          defaultChecked
        />
      ),
    },
    {
      title: "Actions",
      render: (rec) => tableActions(rec),
    },
  ];

  /***** Radio-btn*****/
  const [statusBtn, setStatusBtn] = useState(1);
  onChange = (e) => {
    console.log("radio checked", e.target.value);
    setStatusBtn(e.target.value);
  };
  const closeSearchInput = (
    <div>
      <CloseOutlined onClick={closeSearch} />
    </div>
  );

  return (
    <div className="promo">
      <div className="manage-markup-section">
        <Content className="admin-container">
          <ANTD.Row>
            <ANTD.Col span={24}>
              <div className="card-bt-gap">
                <ANTD.Card bordered={false}>
                  <div className="card-add-heading">
                    <div className="rows-count">
                      <div>
                        <h5>
                          Hotel Room Types{" "}
                          <HelpInfoHelper screenName={"/admin/cartypes"} />
                        </h5>
                        <p>{roomList.length} rows found !</p>
                      </div>
                    </div>
                    <div className="action-images">
                      {showSearchBox && (
                        <ANTD.Input
                          placeholder="Search"
                          onChange={(e) => searchTableData(e)}
                          suffix={closeSearchInput}
                          style={{ padding: "0px 12px" }}
                        />
                      )}
                      &nbsp;&nbsp;
                      <img
                        src={search}
                        alt="search"
                        onClick={(e) => searchData()}
                      />
                      <img
                        src={excel}
                        alt="excel"
                        onClick={(e) =>
                          props.exportExcel(excelList, "Hotel Room Types")
                        }
                      />
                      <p
                        className="add-deposit-icon"
                        onClick={(e) => {
                          if (isEdit) {
                            setIsEdit(false);
                          }
                          handleRoleType(1);
                          setAddMarkupModal(true);
                          actHotelForm.resetFields();
                        }}
                      >
                        <PlusCircleFilled />
                      </p>
                    </div>
                  </div>

                  <div>
                    <ANTD.Table
                      className="table-scroll-none"
                      bordered
                      dataSource={roomList}
                      rowKey={uniqueKey}
                      columns={columns}
                      pagination={{
                        defaultPageSize: 25,
                        showSizeChanger: true,
                        pageSizeOptions: ["25", "50", "100", "125"],
                      }}
                    />
                  </div>
                </ANTD.Card>
              </div>
            </ANTD.Col>
          </ANTD.Row>
        </Content>
      </div>

      <ANTD.Modal
        title={[
          <div>
            <h6 style={{ marginBottom: "0px" }}>
              <strong>{isEdit ? "Update" : "Add"} Hotel Room Types</strong>
            </h6>
          </div>,
        ]}
        className="promo-modal-header hotel-extranet"
        // visible={modalVisible}
        // onOk={(e) => setModalVisible(false)}
        // onCancel={(e) => setModalVisible(false)}
        visible={addMarkupModal}
        onCancel={(e) => setAddMarkupModal(false)}
        footer={null}
        width={"1100px"}
        footer={[
          <div>
            <Button
              key="add"
              type="primary"
              htmlType="submit"
              onClick={actHotelForm.submit}
            >
              {isEdit ? "Update" : "Add"}
            </Button>
            <Button
              key="submit"
              type="danger"
              onClick={() => actHotelForm.resetFields()}
            >
              Clear
            </Button>
          </div>,
        ]}
      >
        <ANTD.Form
          layout={formLayout}
          initialValues={{ layout: formLayout }}
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          form={actHotelForm}
        >
          <ANTD.Row gutter={16}>
            <Col md={24} xs={24}>
              <Form.Item
                label="Room Type Name"
                name="RoomTypeName"
                rules={[{ required: true, message: "Required" }]}
              >
                <Select
                  placeholder="Select Type"
                  onSelect={(val) => handleRoleType(val)}
                >
                  <Select.Option value="Single Room">Single Room</Select.Option>
                  <Select.Option value="Double Room">Double Room</Select.Option>
                  <Select.Option value="Deluxe Room">Deluxe Room</Select.Option>
                  <Select.Option value="Twin Room">Twin Room</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            {/* <ANTD.Col md={24} xs={24}>
              <ANTD.Form.Item
                label="Name"
                name="Name"
                rules={[{ required: true, message: "Please enter nmae" }]}
              >
                <ANTD.Input onChange={getInputValue} />
              </ANTD.Form.Item>
            </ANTD.Col> */}
            <ANTD.Col md={24} xs={24}>
              <Form.Item
                name="Description"
                label="Description"
                rules={[{ required: true }]}
              >
                <TextArea />
              </Form.Item>
            </ANTD.Col>

            <ANTD.Col xs={24} md={8}>
              <ANTD.Form.Item name="phone" label="Image">
                <ANTD.Upload
                  name="avatar"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                >
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt="avatar"
                      style={{ width: "100%" }}
                    />
                  ) : (
                    uploadButton
                  )}
                </ANTD.Upload>
              </ANTD.Form.Item>
            </ANTD.Col>
          </ANTD.Row>
        </ANTD.Form>
      </ANTD.Modal>
    </div>
  );
};

export default UpdatedComponent(Hotelroomtypes);
